module.exports = __webpack_public_path__ + "static/media/area.81bc5bdc.svg";